import { useMemo } from 'react';
import { FieldMessageType, FormField, FieldContainer, FieldContent, FieldLabel, FieldSideContent } from '@shipengine/giger';
import { getCreditCardInputStyles } from './CreditCardStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

let CreditCardFieldType = /*#__PURE__*/function (CreditCardFieldType) {
  CreditCardFieldType["NUMBER"] = "number";
  CreditCardFieldType["CVV"] = "cvv";
  CreditCardFieldType["EXPIRATION_DATE"] = "expirationDate";
  return CreditCardFieldType;
}({});

// https://braintree.github.io/braintree-web/3.67.0/HostedFields.html#~hostedFieldsCard
// Also should be in public-assets -> projects/payment-cards
let SupportedCardImages = /*#__PURE__*/function (SupportedCardImages) {
  SupportedCardImages["american-express"] = "american-express";
  SupportedCardImages["diners-club"] = "diners-club";
  SupportedCardImages["discover"] = "discover";
  SupportedCardImages["jcb"] = "jcb";
  SupportedCardImages["maestro"] = "maestro";
  SupportedCardImages["master-card"] = "master-card";
  SupportedCardImages["unionpay"] = "unionpay";
  SupportedCardImages["visa"] = "visa";
  return SupportedCardImages;
}({});
const CDN_CARDS_PATH = 'apps/payment-cards';
const CreditCardField = _ref => {
  let {
    cardType,
    cdnUrl,
    error,
    hint,
    isEmpty = true,
    isFocused = false,
    isPotentiallyValid = true,
    isValid = true,
    touched = false,
    label,
    type,
    ...rest
  } = _ref;
  const showError = useMemo(() => {
    if (isFocused) {
      return !isPotentiallyValid && !touched;
    }
    return !isValid && touched;
  }, [isFocused, isPotentiallyValid, isValid, touched]);
  const getCardImg = () => {
    const imageName = cardType && SupportedCardImages[cardType] || 'generic';
    return `${cdnUrl}/${CDN_CARDS_PATH}/${imageName}.svg`;
  };
  const creditCardFieldMessage = useMemo(() => {
    if (hint && !showError) {
      return {
        type: FieldMessageType.HINT,
        content: hint
      };
    } else if (error && showError) {
      return {
        type: FieldMessageType.ERROR,
        content: error
      };
    }
    return undefined;
  }, [error, hint, showError]);
  return jsx(FormField, {
    "data-id": `field-container-${type}`,
    message: creditCardFieldMessage,
    ...rest,
    children: jsxs(FieldContainer, {
      isFocused: isFocused,
      isInvalid: !!error && showError,
      children: [jsxs(FieldContent, {
        children: [label && jsx(FieldLabel, {
          htmlFor: `braintree-${type}`,
          hasFocusedValue: isFocused || !isEmpty,
          children: label
        }), jsx("div", {
          id: `braintree-${type}`,
          css: getCreditCardInputStyles(!!label, isPotentiallyValid || isValid)
        })]
      }), type === CreditCardFieldType.NUMBER && cdnUrl && jsx(FieldSideContent, {
        align: "right",
        children: jsx("img", {
          src: getCardImg(),
          alt: cardType
        })
      })]
    })
  });
};

export { CreditCardField, CreditCardFieldType, SupportedCardImages };
//# sourceMappingURL=CreditCardField.js.map
